var __jsx = React.createElement;
import * as React from 'react';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
import styled from 'styled-components';
export function Head(_ref) {
  var _brand$logo$height, _brand$logo$width;

  var brand = _ref.brand;
  return __jsx(Section, null, __jsx(Title, null, brand.logo && __jsx(ds.BlobPicture, {
    size: 105,
    variant: 2,
    sizing: "contain",
    color: "light-green",
    height: (_brand$logo$height = brand.logo.height) !== null && _brand$logo$height !== void 0 ? _brand$logo$height : undefined,
    width: (_brand$logo$width = brand.logo.width) !== null && _brand$logo$width !== void 0 ? _brand$logo$width : undefined,
    src: brand.logo.src
  })
  /*<figure>
      <img
          height={brand.logo.height ?? undefined}
          width={brand.logo.width ?? undefined}
          src={brand.logo.src}
      />
  </figure>*/
  , __jsx(S.heading.Title4, {
    as: "h1"
  }, brand.name)), __jsx(S.copy.Text1, {
    as: "p"
  }, brand.descriptionShort), __jsx(S.copy.Text4, {
    as: "p"
  }, creation(brand)));
}

function creation(brand) {
  if (brand.creation.year) {
    var _creation = ["Marque cr\xE9\xE9e en ".concat(brand.creation.year)];

    if (brand.creation.city) {
      _creation.push("\xE0 ".concat(brand.creation.city));

      var loc = [];

      if (brand.creation.region) {
        loc.push(brand.creation.region);
      }

      if (brand.creation.country) {
        loc.push(brand.creation.country);
      }

      if (loc.length !== 0) {
        _creation.push("(".concat(loc.join(', '), ")"));
      }
    } else if (brand.creation.country) _creation.push("(".concat(brand.creation.country, ")"));

    return "".concat(_creation.join(' '), ".");
  } else return "Pays de cr\xE9ation de la marque : ".concat(brand.creation.country, ".");
}

var Title = styled.div.withConfig({
  displayName: "Head__Title",
  componentId: "sc-t1qx87-0"
})(["display:flex;flex-direction:row;align-items:center;margin-bottom:20px;@media not screen and (", "){hyphens:auto;}@media screen and (", "){margin-bottom:30px;}", "{flex:0;padding:11.666px;margin:-11.666px;@media screen and (", "){padding:20px;margin:-20px;}", "{width:105px;height:105px;@media screen and (", "){width:180px;height:180px;}}", "{background:white;}}", "{margin-left:10px;@media screen and (", "){margin-left:30px;}}"], ds.breakpoint.TABLET, ds.breakpoint.TABLET, ds.BlobPicture, ds.breakpoint.TABLET, S.picture.Picture, ds.breakpoint.TABLET, S.picture.Image, S.heading.Title4, ds.breakpoint.TABLET);
var Section = styled.section.withConfig({
  displayName: "Head__Section",
  componentId: "sc-t1qx87-1"
})(["@media not screen and (", "){margin-top:45px;}", "{margin-top:10px;}"], ds.breakpoint.TABLET, S.copy.Text4);